import { render, staticRenderFns } from "./RegistrarNuevaLicenciaDialogComponent.vue?vue&type=template&id=08076b20"
import script from "./RegistrarNuevaLicenciaDialogComponent.vue?vue&type=script&lang=js"
export * from "./RegistrarNuevaLicenciaDialogComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports